import { render, staticRenderFns } from "./MaterialSelection.vue?vue&type=template&id=9e9f6ecc&"
import script from "./MaterialSelection.vue?vue&type=script&lang=js&"
export * from "./MaterialSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports